import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Integration } from "../../../_statics/Integration";
import { getIntegrationSquareLogo } from "../../../_statics/IntegrationBrand";

// The rail entry's mark, for the integrations that have no Font Awesome brand glyph — Klarna, Mollie,
// WooCommerce and friends were left with a generic cart or euro sign although the mark is in the repo.
//
// The asset is desaturated rather than used as a mask. A mask keeps only the silhouette, which flattened
// WooCommerce into a blank speech bubble and cost Shopify its S; desaturating keeps every interior detail and
// only removes the colour.
const Mark = styled.img`
    width: 16px;
    height: 16px;
    flex: none;
    object-fit: contain;
    filter: grayscale(1) opacity(0.75);
`;

// Font Awesome's own brand glyphs are already monochrome and already correct, so an entry that has one keeps
// it. This is the guard that makes the component unable to touch Shopify, Stripe, TikTok, Amazon, eBay,
// Squarespace, Shopware or PayPal.
const hasBrandGlyph = (icon) => !!icon && icon.startsWith("fab ");

export const getNavBrandLogo = (url, icon) => {
    if (!url || hasBrandGlyph(icon)) {
        return null;
    }

    const match = Object.values(Integration)
        .filter((integration) => integration && integration.integrationPath && integration.identifier)
        .find((integration) => url.endsWith(integration.integrationPath));

    return match ? getIntegrationSquareLogo(match.identifier) || null : null;
};

const NavBrandGlyph = ({ url, icon }) => {
    const logo = getNavBrandLogo(url, icon);

    if (!logo) {
        return <i className={icon} aria-hidden="true" />;
    }

    return <Mark src={logo} alt="" aria-hidden="true" />;
};

NavBrandGlyph.propTypes = {
    url: PropTypes.string,
    icon: PropTypes.string,
};

export default NavBrandGlyph;
